import { useInfiniteQuery } from "@tanstack/react-query";
import apiClient from "lib/api-client";


const fetchSubCategories = async ({ pageParam = 1, queryKey }) => {
    const [, { categoryName, limit, sortBy, sortOrder, searchTerm , startDate, endDate }] = queryKey;
    const response = await apiClient.post("/api/v1/collection/getSubCategoryFromSelectOrders", {
      categoryName,
      pageNumber: pageParam,
      limit,
      sortBy,
      sortOrder,
      searchTerm,
      startDate,
      endDate,
    });
  
    if (response.status !== 200) {
      throw new Error("Error fetching categories");
    }
  
    return {
      subCategories: response.data.subCategories,
      totalUniqueSubCategoryCount: response.data.totalUniqueSubCategoryCount,
      nextPage: response.data.pagination.pageNumber + 1,
      totalPages: response.data.pagination.totalPages,
    };
  };



export const useCollectionSubCategories = ({ categoryName = "", limit = 10, sortBy = "alphabetical", sortOrder = "asc", searchTerm = "", startDate = "", endDate = "" }) => {
    return useInfiniteQuery({
      queryKey: ["subcategories", { categoryName, limit, sortBy, sortOrder, searchTerm, startDate , endDate }],
      queryFn: ({ pageParam = 1 }) => fetchSubCategories({ pageParam, queryKey: ["subcategories", { categoryName, limit, sortBy, sortOrder, searchTerm , startDate , endDate }] }),
      getNextPageParam: (lastPage) => {
        if (lastPage.nextPage <= lastPage.totalPages) {
          return lastPage.nextPage;
        }
        return undefined;
      },
      staleTime: 5 * 60 * 1000,
      retry: 1,
      select: (data) => {
        return {
          ...data,
          pages: data?.pages?.map((page) => ({
            ...page,
            subCategories: page.subCategories.filter((subCate) => subCate?.count >= 1),
          })),
        };
      },
    });
  };